export function LoadingState() {
  return <main className="center-screen"><div className="loading-heart" aria-label="Cargando">♥</div><p>Preparando la aventura…</p></main>;
}

export function ErrorState({ message }: { message: string }) {
  return <main className="center-screen"><div className="error-card"><span className="big-icon">☁️</span><h1>No pudimos abrir la historia</h1><p>{message}</p><button className="button button-primary" onClick={() => window.location.reload()}>Reintentar</button></div></main>;
}

